import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TaskWindow, { TaskWindowContent } from '@xingternal/malt-task-window';

class ModalInfo extends Component {
  static propTypes = {
    children: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };

    this.openModal = this.openModal.bind(this);
    this.renderModalContent = this.renderModalContent.bind(this);
  }

  openModal(event) {
    event.preventDefault();
    this.setState({ showModal: true });
  }

  renderModalContent(content) {
    if (!this.state.showModal) return null;

    return (
      <TaskWindow onClose={() => this.setState({ showModal: false })}>
        <TaskWindowContent fill={true}>{content}</TaskWindowContent>
      </TaskWindow>
    );
  }

  render() {
    return this.props.children(this.openModal, this.renderModalContent);
  }
}

export default ModalInfo;
